import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import api from '../lib/api';
import { Star, Loader2, MessageCircle, FileText } from 'lucide-react';
import { formatLastSeen } from '../lib/time';
import { useNavigate } from 'react-router-dom';

function formatWhen(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString('it-IT', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
  } catch { return ''; }
}

export default function Preferiti() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/messages/starred').then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  const openChat = (m) => {
    // For admins the chat is at /admin/chat/{peer}; users only have /chat
    if (user.is_admin) {
      const peer = m.sender_id === user.id ? m.recipient_id : m.sender_id;
      navigate(`/admin/chat/${peer}`);
    } else {
      navigate('/chat');
    }
  };

  return (
    <Layout title="Preferiti" showBack backTo="/home">
      <div className="px-5 pt-6 pb-8 max-w-md mx-auto space-y-3">
        <div className="flex items-center gap-2 text-white/80">
          <Star className="w-5 h-5 text-[var(--gold)] fill-[var(--gold)]" />
          <h2 className="font-heading text-lg">Messaggi con la stella</h2>
        </div>
        {items === null && (
          <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-white/40" /></div>
        )}
        {items && items.length === 0 && (
          <div className="card-surface p-6 text-center text-sm text-white/60" data-testid="preferiti-empty">
            Nessun messaggio preferito.<br />
            <span className="text-[11px] text-white/40">Tieni premuto un messaggio nella chat e tocca ★ per aggiungerlo qui.</span>
          </div>
        )}
        {items && items.map((m) => (
          <button
            key={m.id}
            data-testid={`starred-${m.id}`}
            onClick={() => openChat(m)}
            className="card-surface p-3 w-full text-left space-y-1 hover:border-[var(--gold)]/30 transition-colors"
          >
            <div className="flex items-center justify-between text-[11px] text-white/50">
              <span className="flex items-center gap-1"><MessageCircle className="w-3 h-3" /> {m.sender_username || 'Messaggio'}</span>
              <span>{formatWhen(m.created_at)}</span>
            </div>
            {m.type === 'text' ? (
              <div className="text-sm text-white/90 whitespace-pre-wrap break-words line-clamp-4">{m.content}</div>
            ) : (
              <div className="text-sm text-white/80 flex items-center gap-2">
                <FileText className="w-4 h-4 text-[var(--gold)]" />
                {m.file_name || m.type}
              </div>
            )}
          </button>
        ))}
      </div>
    </Layout>
  );
}
